import React, { useRef, useContext, useState, useEffect, useMemo, cloneElement, useCallback } from 'react';
import { useGesture } from 'react-use-gesture';
import { nanoid } from 'nanoid/non-secure';
import '../../utils/assertions.es.js';
import { ResponsiveContext } from '../../utils/responsive.es.js';
import { scrollIntoView } from '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import styled from 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Skeleton } from '../Skeleton/Skeleton.es.js';
import '../../assets/icons/custom/CheckIcon.es.js';
import '../../assets/icons/generated/filled/AndroidFilled.es.js';
import '../../assets/icons/generated/filled/AppleFilled.es.js';
import '../../assets/icons/generated/filled/ArrowForwardFilled.es.js';
import '../../assets/icons/generated/filled/CameraAddFilled.es.js';
import '../../assets/icons/generated/filled/CameraFilled.es.js';
import '../../assets/icons/generated/filled/CdPauseFilled.es.js';
import '../../assets/icons/generated/filled/CheckCircleFilled.es.js';
import '../../assets/icons/generated/filled/CommentsFilled.es.js';
import '../../assets/icons/generated/filled/CommentsTextFilled.es.js';
import '../../assets/icons/generated/filled/CreditCardFilled.es.js';
import '../../assets/icons/generated/filled/CrownFilled.es.js';
import '../../assets/icons/generated/filled/DownloadCircleFilled.es.js';
import '../../assets/icons/generated/filled/FacebookFilled.es.js';
import '../../assets/icons/generated/filled/FolderFilled.es.js';
import '../../assets/icons/generated/filled/HeartFilled.es.js';
import '../../assets/icons/generated/filled/HelpFilled.es.js';
import '../../assets/icons/generated/filled/InfoFilled.es.js';
import '../../assets/icons/generated/filled/InstagramFilled.es.js';
import '../../assets/icons/generated/filled/KebabFilled.es.js';
import '../../assets/icons/generated/filled/LightningFilled.es.js';
import '../../assets/icons/generated/filled/LinkFilled.es.js';
import '../../assets/icons/generated/filled/LinkedinFilled.es.js';
import '../../assets/icons/generated/filled/LockFilled.es.js';
import '../../assets/icons/generated/filled/MasterFilled.es.js';
import '../../assets/icons/generated/filled/MeatballsFilled.es.js';
import '../../assets/icons/generated/filled/PauseFilled.es.js';
import '../../assets/icons/generated/filled/PlayFilled.es.js';
import '../../assets/icons/generated/filled/RecordFilled.es.js';
import '../../assets/icons/generated/filled/RedditFilled.es.js';
import '../../assets/icons/generated/filled/ReleasesFilled.es.js';
import '../../assets/icons/generated/filled/RemoveFilled.es.js';
import '../../assets/icons/generated/filled/ReplyFilled.es.js';
import '../../assets/icons/generated/filled/SpotifyFilled.es.js';
import '../../assets/icons/generated/filled/StarFilled.es.js';
import '../../assets/icons/generated/filled/StarHalfFilled.es.js';
import '../../assets/icons/generated/filled/StopFilled.es.js';
import '../../assets/icons/generated/filled/TwitterFilled.es.js';
import '../../assets/icons/generated/filled/UsersFilled.es.js';
import '../../assets/icons/generated/filled/VolumeFilled.es.js';
import '../../assets/icons/generated/filled/VolumeMuteFilled.es.js';
import '../../assets/icons/generated/filled/WarningFilled.es.js';
import '../../assets/icons/generated/filled/WindowsFilled.es.js';
import '../../assets/icons/generated/filled/XFilled.es.js';
import '../../assets/icons/generated/filled/YoutubeFilled.es.js';
import '../../assets/icons/generated/outlined/CalendarOutlined.es.js';
import '../../assets/icons/generated/outlined/AddFileOutlined.es.js';
import '../../assets/icons/generated/outlined/AddOutlined.es.js';
import '../../assets/icons/generated/outlined/AddReleaseOutlined.es.js';
import '../../assets/icons/generated/outlined/AddToCollectionOutlined.es.js';
import '../../assets/icons/generated/outlined/AddSongOutlined.es.js';
import '../../assets/icons/generated/outlined/AlbumOutlined.es.js';
import '../../assets/icons/generated/outlined/ArchiveOutlined.es.js';
import ArrowBackOutlined from '../../assets/icons/generated/outlined/ArrowBackOutlined.es.js';
import ArrowForwardOutlined from '../../assets/icons/generated/outlined/ArrowForwardOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowDownOutlined.es.js';
import '../../assets/icons/generated/outlined/ArrowUpOutlined.es.js';
import '../../assets/icons/generated/outlined/AttachmentOutlined.es.js';
import '../../assets/icons/generated/outlined/BassOutlined.es.js';
import '../../assets/icons/generated/outlined/BellOutlinedOff.es.js';
import '../../assets/icons/generated/outlined/BellOutlined.es.js';
import '../../assets/icons/generated/outlined/BentoOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOffOutlined.es.js';
import '../../assets/icons/generated/outlined/CameraOutlined.es.js';
import '../../assets/icons/generated/outlined/CancelOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretDownOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretRightOutlined.es.js';
import '../../assets/icons/generated/outlined/CaretUpOutlined.es.js';
import '../../assets/icons/generated/outlined/CdArrowOutlined.es.js';
import '../../assets/icons/generated/outlined/CdTimerOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckOutlined.es.js';
import '../../assets/icons/generated/outlined/CheckCircleOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockHistoryOutlined.es.js';
import '../../assets/icons/generated/outlined/ClockOutlined.es.js';
import '../../assets/icons/generated/outlined/CloseOutlined.es.js';
import '../../assets/icons/generated/outlined/CloudUploadOutlined.es.js';
import '../../assets/icons/generated/outlined/CogOutlined.es.js';
import '../../assets/icons/generated/outlined/CommentMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/ComputerDesktopOutlined.es.js';
import '../../assets/icons/generated/outlined/CopyOutlined.es.js';
import '../../assets/icons/generated/outlined/CouponOutlined.es.js';
import '../../assets/icons/generated/outlined/CreditCardOutlined.es.js';
import '../../assets/icons/generated/outlined/CrownOutlined.es.js';
import '../../assets/icons/generated/outlined/DeliveryOutlined.es.js';
import '../../assets/icons/generated/outlined/DiskOutlined.es.js';
import '../../assets/icons/generated/outlined/DownloadOutlined.es.js';
import '../../assets/icons/generated/outlined/DragOutlined.es.js';
import '../../assets/icons/generated/outlined/DrumsOutlined.es.js';
import '../../assets/icons/generated/outlined/EditOutlined.es.js';
import '../../assets/icons/generated/outlined/EmojiOutlined.es.js';
import '../../assets/icons/generated/outlined/ExpandOutlined.es.js';
import '../../assets/icons/generated/outlined/ExternalLinkOutlined.es.js';
import '../../assets/icons/generated/outlined/FeatherOutlined.es.js';
import '../../assets/icons/generated/outlined/FileOutlined.es.js';
import '../../assets/icons/generated/outlined/FileTextOutlined.es.js';
import '../../assets/icons/generated/outlined/FilterOutlined.es.js';
import '../../assets/icons/generated/outlined/FiltersOutlined.es.js';
import '../../assets/icons/generated/outlined/FlagOutlined.es.js';
import '../../assets/icons/generated/outlined/FolderMusic.es.js';
import '../../assets/icons/generated/outlined/FolderOutlined.es.js';
import '../../assets/icons/generated/outlined/GiftOutlined.es.js';
import '../../assets/icons/generated/outlined/GlobeOutlined.es.js';
import '../../assets/icons/generated/outlined/GrandPianoOutlined.es.js';
import '../../assets/icons/generated/outlined/GridOutlined.es.js';
import '../../assets/icons/generated/outlined/GuitarOutlined.es.js';
import '../../assets/icons/generated/outlined/HandOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesAddOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesCheckedOutlined.es.js';
import '../../assets/icons/generated/outlined/HeadphonesOutlined.es.js';
import '../../assets/icons/generated/outlined/HeartOutlined.es.js';
import '../../assets/icons/generated/outlined/HelpOutlined.es.js';
import '../../assets/icons/generated/outlined/HideOutlined.es.js';
import '../../assets/icons/generated/outlined/ImageOutlined.es.js';
import '../../assets/icons/generated/outlined/InfoOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyOutlined.es.js';
import '../../assets/icons/generated/outlined/KeyboardOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveLeftOutlined.es.js';
import '../../assets/icons/generated/outlined/LeaveOutlined.es.js';
import '../../assets/icons/generated/outlined/ListOutlined.es.js';
import '../../assets/icons/generated/outlined/ListUnorderedOutlined.es.js';
import '../../assets/icons/generated/outlined/ListMusicNoteOutlined.es.js';
import '../../assets/icons/generated/outlined/LockOutlined.es.js';
import '../../assets/icons/generated/outlined/LogoOutlined.es.js';
import '../../assets/icons/generated/outlined/LoopOutlined.es.js';
import '../../assets/icons/generated/outlined/MagicWandOutlined.es.js';
import '../../assets/icons/generated/outlined/MailOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuInvertedOutlined.es.js';
import '../../assets/icons/generated/outlined/MenuOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MicrophoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MinimizeOutlined.es.js';
import '../../assets/icons/generated/outlined/MinusOutlined.es.js';
import '../../assets/icons/generated/outlined/MobilePhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/MoneyOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOffOutlined.es.js';
import '../../assets/icons/generated/outlined/MonitorOutlined.es.js';
import '../../assets/icons/generated/outlined/MoveToFolderOutlined.es.js';
import '../../assets/icons/generated/outlined/MusicNoteOff.es.js';
import '../../assets/icons/generated/outlined/MusicNote.es.js';
import '../../assets/icons/generated/outlined/NetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/NoteOutlined.es.js';
import '../../assets/icons/generated/outlined/OrderOutlined.es.js';
import '../../assets/icons/generated/outlined/PackOutlined.es.js';
import '../../assets/icons/generated/outlined/PaperPlaneOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilOutlined.es.js';
import '../../assets/icons/generated/outlined/PencilPaperOutlined.es.js';
import '../../assets/icons/generated/outlined/PercentageOutlined.es.js';
import '../../assets/icons/generated/outlined/PhoneOutlined.es.js';
import '../../assets/icons/generated/outlined/PianoOutlined.es.js';
import '../../assets/icons/generated/outlined/PlaylistOutlined.es.js';
import '../../assets/icons/generated/outlined/PlusOutlined.es.js';
import '../../assets/icons/generated/outlined/PreserverOutlined.es.js';
import '../../assets/icons/generated/outlined/PriceTagOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductBlogOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductNetworkOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductPluginsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductProjectsOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductReleasesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProductSamplesOutlined.es.js';
import '../../assets/icons/generated/outlined/ProfileOutlined.es.js';
import '../../assets/icons/generated/outlined/ProviderOutlined.es.js';
import '../../assets/icons/generated/outlined/QuoteOutlined.es.js';
import '../../assets/icons/generated/outlined/RemoveOutlined.es.js';
import '../../assets/icons/generated/outlined/RepeatOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplaceOutlined.es.js';
import '../../assets/icons/generated/outlined/ReplyOutlined.es.js';
import '../../assets/icons/generated/outlined/SearchOutlined.es.js';
import '../../assets/icons/generated/outlined/SendFileToOutlined.es.js';
import '../../assets/icons/generated/outlined/SharingOutlined.es.js';
import '../../assets/icons/generated/outlined/ShowOutlined.es.js';
import '../../assets/icons/generated/outlined/SidebarOutlined.es.js';
import '../../assets/icons/generated/outlined/SliderOutlined.es.js';
import '../../assets/icons/generated/outlined/SoundOutlined.es.js';
import '../../assets/icons/generated/outlined/StarOutlined.es.js';
import '../../assets/icons/generated/outlined/StoreOutlined.es.js';
import '../../assets/icons/generated/outlined/SuccessOutlined.es.js';
import '../../assets/icons/generated/outlined/SunOutlined.es.js';
import '../../assets/icons/generated/outlined/ThreadOutlined.es.js';
import '../../assets/icons/generated/outlined/TiktokOutlined.es.js';
import '../../assets/icons/generated/outlined/TrashOutlined.es.js';
import '../../assets/icons/generated/outlined/TrendingUpOutlined.es.js';
import '../../assets/icons/generated/outlined/UpDownOutlined.es.js';
import '../../assets/icons/generated/outlined/UploadOutlined.es.js';
import '../../assets/icons/generated/outlined/UserMessageOutlined.es.js';
import '../../assets/icons/generated/outlined/UserOutlined.es.js';
import '../../assets/icons/generated/outlined/UserPlusOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoChatOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOffOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOnOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoRecordingOutlined.es.js';
import '../../assets/icons/generated/outlined/VideoSquareOutlined.es.js';
import '../../assets/icons/generated/outlined/WarningOutlined.es.js';
import '../../assets/icons/generated/products/Blog.es.js';
import '../../assets/icons/generated/products/ChromaticDark.es.js';
import '../../assets/icons/generated/products/Chromatic.es.js';
import '../../assets/icons/generated/products/CommunityChannels.es.js';
import '../../assets/icons/generated/products/Courses.es.js';
import '../../assets/icons/generated/products/Creator.es.js';
import '../../assets/icons/generated/products/Distribution.es.js';
import '../../assets/icons/generated/products/Insider.es.js';
import '../../assets/icons/generated/products/LandrFx.es.js';
import '../../assets/icons/generated/products/Mastering.es.js';
import '../../assets/icons/generated/products/NetworkPro.es.js';
import '../../assets/icons/generated/products/NetworkServices.es.js';
import '../../assets/icons/generated/products/Network.es.js';
import '../../assets/icons/generated/products/Plugins.es.js';
import '../../assets/icons/generated/products/ProjectsBlue.es.js';
import '../../assets/icons/generated/products/ProjectsRed.es.js';
import '../../assets/icons/generated/products/SamplesDark.es.js';
import '../../assets/icons/generated/products/Samples.es.js';
import '../../assets/icons/generated/products/SessionsDark.es.js';
import '../../assets/icons/generated/products/Sessions.es.js';
import '../../assets/icons/generated/products/Tutorials.es.js';
import '../../assets/icons/generated/products/Vocalign.es.js';
import { useBreakpoint } from '../../hooks/useBreakpoint/useBreakpoint.es.js';
import { useDebouncedCallback } from '../../hooks/useDebouncedCallback/useDebouncedCallback.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import { IconButton } from '../IconButton/IconButton.es.js';
import { getItemsPerPage } from './helpers.es.js';
import { Styled } from './styled.es.js';
import DotNavigation from './components/DotNavigation.es.js';
import useAutoNavigation from './useAutoNavigation.es.js';
import getSuggestedCurrentSlide from './helpers/getSuggestedCurrentSlide.es.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const arrows = [
  { direction: "left", key: "ArrowLeft" },
  { direction: "right", key: "ArrowRight" }
];
const ArrowButton = styled(IconButton).attrs(({ side }) => ({
  hideTooltip: true,
  variant: "secondary",
  kind: "solid",
  isRounded: true,
  "data-testid": `arrow-${side}`,
  icon: side === "left" ? ArrowBackOutlined : ArrowForwardOutlined
}))`
    transition: all 0.5s ease;
`;
const Carousel = (_a) => {
  var _b = _a, {
    items,
    slidesPerPage,
    onNavigate,
    gutter,
    arrowOffset,
    arrowPosition = "outside",
    hideArrows = false,
    itemsOffset,
    keyboardNavigation,
    scrollToSelection,
    selectionEnabled = true,
    initialSelection = 0,
    onSlideSelected,
    lazyloading = true,
    dotPosition,
    dotSize = "xxl",
    autoNavigationDelay
  } = _b, props = __objRest(_b, [
    "items",
    "slidesPerPage",
    "onNavigate",
    "gutter",
    "arrowOffset",
    "arrowPosition",
    "hideArrows",
    "itemsOffset",
    "keyboardNavigation",
    "scrollToSelection",
    "selectionEnabled",
    "initialSelection",
    "onSlideSelected",
    "lazyloading",
    "dotPosition",
    "dotSize",
    "autoNavigationDelay"
  ]);
  const carouselContainerRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const { breakpoints } = useContext(ResponsiveContext);
  const [hasBeenInteracted, setHasBeenInteracted] = useState(false);
  useEffect(() => {
    const currentCarouselContainer = carouselContainerRef.current;
    if (!currentCarouselContainer) {
      return;
    }
    function handleBeenInteracted() {
      setHasBeenInteracted(true);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("mouseover", handleBeenInteracted);
      currentCarouselContainer == null ? void 0 : currentCarouselContainer.removeEventListener("touchstart", handleBeenInteracted);
    }
    currentCarouselContainer.addEventListener("mouseover", handleBeenInteracted);
    currentCarouselContainer.addEventListener("touchstart", handleBeenInteracted);
    return () => {
      currentCarouselContainer.removeEventListener("mouseover", handleBeenInteracted);
      currentCarouselContainer.removeEventListener("touchstart", handleBeenInteracted);
    };
  }, []);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [currentSelection, setCurrentSelection] = useState(initialSelection);
  const [arrowsVisibleState, setArrowsVisibleState] = useState({
    left: false,
    right: false
  });
  const isMobile = useBreakpoint("md");
  const isBreakPointXXL = useBreakpoint("xxl");
  useEnhancedEffect(() => {
    const currentScrollContainer = scrollContainerRef.current;
    if (!currentScrollContainer) {
      return;
    }
    function preventKeyboardScroll(e) {
      if ([32, 37, 38, 39, 40].includes(e.keyCode)) {
        e.preventDefault();
      }
    }
    currentScrollContainer.addEventListener("keydown", preventKeyboardScroll);
    return () => {
      currentScrollContainer.removeEventListener("keydown", preventKeyboardScroll);
    };
  }, []);
  const itemsPerPage = useMemo(() => typeof slidesPerPage === "number" ? slidesPerPage : getItemsPerPage(slidesPerPage, breakpoints), [breakpoints, slidesPerPage]);
  const itemsToRender = useMemo(() => {
    return items.map((item, index) => {
      const isPreloadAllowed = lazyloading && !hasBeenInteracted ? index <= itemsPerPage : true;
      if (!item.key) {
        throw new Error("Each Carousel Slide must have a unique key.");
      }
      return /* @__PURE__ */ React.createElement(Styled.CarouselSlide, {
        key: item.key,
        gutter: gutter || 0,
        slidesPerPage: itemsPerPage,
        "data-carousel-slide": index,
        offset: itemsOffset
      }, isPreloadAllowed && /* @__PURE__ */ React.createElement(Styled.CarouselSlideInner, {
        offset: itemsOffset
      }, cloneElement(item, {
        draggable: false,
        onMouseDown: (event) => event.preventDefault(),
        isSelected: selectionEnabled ? index === currentSelection : void 0,
        setSelected: selectionEnabled ? () => {
          setCurrentSelection(index);
        } : void 0
      })), !isPreloadAllowed && /* @__PURE__ */ React.createElement(Styled.CarouselSlideInner, {
        offset: itemsOffset
      }, /* @__PURE__ */ React.createElement(Skeleton, null)));
    });
  }, [currentSelection, gutter, items, itemsOffset, itemsPerPage, selectionEnabled, hasBeenInteracted, lazyloading]);
  useEffect(() => {
    let left = false, right = false;
    if (!isMobile && !hideArrows) {
      left = currentSlide !== 0;
      right = currentSlide < items.length - itemsPerPage;
    }
    setArrowsVisibleState({
      left,
      right
    });
  }, [currentSlide, isMobile, items.length, itemsPerPage, hideArrows]);
  const handleScroll = useDebouncedCallback((slide, setSlide) => {
    if (scrollContainerRef.current) {
      const slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);
      if (slide !== slideNumber) {
        setSlide(slideNumber);
        setCurrentSlide(slideNumber);
        setCurrentSelection(slideNumber);
        scrollToSlide(slideNumber);
      } else {
        scrollToSlide(slide);
      }
    }
  }, 300);
  const scrollToSlide = useCallback((slideNumber, withScrollIntoView = true) => {
    const currentScrollContainer = scrollContainerRef.current;
    if (!currentScrollContainer) {
      return;
    }
    const slide = currentScrollContainer.querySelector(`[data-carousel-slide="${slideNumber}"]`);
    setCurrentSelection(slideNumber);
    if (onNavigate && currentSlide !== slideNumber) {
      onNavigate(slideNumber);
    }
    if (slide && withScrollIntoView) {
      scrollIntoView(slide, {
        behavior: "smooth",
        inline: "start",
        block: "nearest",
        boundary: currentScrollContainer
      });
    }
  }, [onNavigate, currentSlide]);
  const updateSlide = useDebouncedCallback(() => {
    if (scrollContainerRef.current) {
      const slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);
      scrollToSlide(slideNumber);
    }
  }, 300);
  const handleDotNavigationClick = useCallback((slideNumber, withScrollIntoView = true) => {
    onSlideSelected && onSlideSelected(slideNumber);
    scrollToSlide(slideNumber, withScrollIntoView);
  }, [onSlideSelected, scrollToSlide]);
  useEnhancedEffect(() => {
    window.addEventListener("resize", updateSlide);
    return () => window.removeEventListener("resize", updateSlide);
  }, []);
  const getNextCurrentSlide = useCallback((side, numberToScroll) => {
    const scrollBy = typeof numberToScroll === "undefined" ? itemsPerPage : numberToScroll;
    return side === "ArrowRight" ? Math.min(currentSlide + scrollBy, items.length - itemsPerPage) : Math.max(currentSlide - scrollBy, 0);
  }, [currentSlide, items.length, itemsPerPage]);
  const changeCurrentSlide = useCallback((side, numberToScroll) => {
    setHasBeenInteracted(true);
    const newCurrentSlide = getNextCurrentSlide(side, numberToScroll);
    setCurrentSlide(newCurrentSlide);
    setCurrentSelection(newCurrentSlide);
    scrollToSlide(newCurrentSlide);
  }, [getNextCurrentSlide, scrollToSlide]);
  const autoscrollToSelection = useCallback((newSelection) => {
    if (scrollToSelection && newSelection !== null) {
      const isSelectionOffPage = newSelection < currentSlide || newSelection >= currentSlide + itemsPerPage;
      if (isSelectionOffPage) {
        const pageWithSelection = itemsPerPage * Math.floor(newSelection / itemsPerPage);
        setCurrentSlide(pageWithSelection);
        scrollToSlide(pageWithSelection);
      }
    }
  }, [scrollToSelection, currentSlide, itemsPerPage, scrollToSlide]);
  const changeSelection = useCallback((side) => {
    if (!selectionEnabled) {
      return;
    }
    let newSelection = currentSelection;
    if (currentSelection === null) {
      newSelection = 0;
    } else if (side === "ArrowLeft" && currentSelection > 0) {
      newSelection = currentSelection - 1;
    } else if (side === "ArrowRight" && currentSelection < items.length - 1) {
      newSelection = currentSelection + 1;
    }
    setHasBeenInteracted(true);
    setCurrentSelection(newSelection);
    newSelection && autoscrollToSelection(newSelection);
    onSlideSelected && onSlideSelected(newSelection);
  }, [autoscrollToSelection, currentSelection, items.length, onSlideSelected, selectionEnabled]);
  useEffect(() => {
    function handleKeyDown(e) {
      const { key } = e;
      if (key === "ArrowRight" || key === "ArrowLeft") {
        if (keyboardNavigation === "page") {
          changeCurrentSlide(key, itemsPerPage);
        } else if (typeof keyboardNavigation === "number") {
          changeCurrentSlide(key, keyboardNavigation);
        } else if (keyboardNavigation === "selection") {
          changeSelection(key);
        }
      }
    }
    if (keyboardNavigation) {
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [changeCurrentSlide, changeSelection, itemsPerPage, keyboardNavigation]);
  useEffect(() => {
    const currentScrollContainer = scrollContainerRef.current;
    if (!currentScrollContainer) {
      return;
    }
    const boundScrollFunction = handleScroll.bind({}, currentSlide, setCurrentSlide);
    currentScrollContainer.addEventListener("scroll", boundScrollFunction);
    return () => {
      currentScrollContainer.removeEventListener("scroll", boundScrollFunction);
    };
  }, [itemsPerPage, onNavigate, items, handleScroll, currentSlide, isMobile]);
  const momentumID = useRef(0);
  const scrollLeftMomentum = useCallback((velocity, movement) => {
    let velocityRef = Math.min(velocity, 10);
    function momentumLoop() {
      if (scrollContainerRef == null ? void 0 : scrollContainerRef.current) {
        const previousScrollLeft = scrollContainerRef.current.scrollLeft;
        scrollContainerRef.current.scrollLeft -= velocityRef / 10 * movement;
        velocityRef *= 0.95;
        if (previousScrollLeft !== scrollContainerRef.current.scrollLeft && Math.abs(velocityRef) > 0.5) {
          momentumID.current = requestAnimationFrame(momentumLoop);
        }
      }
    }
    cancelAnimationFrame(momentumID.current);
    momentumID.current = requestAnimationFrame(momentumLoop);
  }, []);
  useEffect(() => {
    return () => {
      cancelAnimationFrame(momentumID.current);
    };
  }, []);
  const hasDragged = React.useRef(false);
  const bindGesture = useGesture({
    onDrag: ({ first, last, event, velocity, movement, delta: [mx] }) => {
      if (first) {
        hasDragged.current = true;
      }
      if (last) {
        setTimeout(() => {
          hasDragged.current = false;
        }, 0);
      }
      if (scrollContainerRef == null ? void 0 : scrollContainerRef.current) {
        if ((event == null ? void 0 : event.type) === "mousemove") {
          scrollContainerRef.current.scrollLeft -= mx;
        }
        if ((event == null ? void 0 : event.type) === "mouseup") {
          scrollLeftMomentum(velocity, movement[0]);
        }
      }
    },
    onScroll: ({ last }) => {
      if (last && scrollContainerRef.current) {
        const slideNumber = getSuggestedCurrentSlide(scrollContainerRef.current);
        scrollToSlide(slideNumber, false);
      }
    },
    onClickCapture: (event) => {
      if (hasDragged.current) {
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }, {
    drag: {
      axis: "x",
      filterTaps: true
    }
  });
  const { ariaLive, isAutoNavigatingActive } = useAutoNavigation({
    carouselContainerRef,
    currentSelection,
    autoNavigationDelay,
    length: items.length,
    setCurrentSelection,
    scrollToSlide,
    setHasBeenInteracted
  });
  const transitionDelay = isAutoNavigatingActive ? autoNavigationDelay : 0;
  const arrowOffsetFromDotSize = dotPosition === "outside" ? dotSize : void 0;
  return /* @__PURE__ */ React.createElement(Styled.Wrapper, __spreadValues({
    ref: carouselContainerRef,
    role: "region",
    "aria-live": ariaLive,
    id: `carousel-${nanoid()}`
  }, props), /* @__PURE__ */ React.createElement(Styled.ScrollContainer, __spreadValues({
    ref: scrollContainerRef,
    gutter,
    offset: itemsOffset,
    isMobile
  }, bindGesture()), itemsToRender), arrows.map(({ direction, key }) => /* @__PURE__ */ React.createElement(Styled.ArrowWrapper, {
    direction,
    arrowPosition,
    key: `carousel-arrow-${direction}`,
    className: arrowsVisibleState[direction] ? "showing" : ""
  }, /* @__PURE__ */ React.createElement(ArrowButton, {
    label: "",
    hideTooltip: true,
    size: isBreakPointXXL ? "sm" : "md",
    side: direction,
    onClick: () => changeCurrentSlide(key, itemsPerPage),
    mb: arrowOffset || arrowOffsetFromDotSize
  }))), dotPosition && /* @__PURE__ */ React.createElement(DotNavigation, {
    dotPosition,
    dotSize,
    length: items.length,
    currentSelection,
    onClick: handleDotNavigationClick,
    transitionDelay
  }));
};
Carousel.displayName = "Carousel";

export { Carousel };
//# sourceMappingURL=Carousel.es.js.map
